import dJSON from 'dirty-json';
import Splide from '@splidejs/splide';
import {
  animate, onScroll, stagger,
} from 'animejs';

const moduleSelector = '.usp-strip';

/**
 * Module Init
 */
(() => {
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  modules.forEach((query) => {
    try {
      query.querySelector('script')?.remove();

      const { data } = dJSON.parse(query.data);
      if (!Array.isArray(data) || !data.length) return;

      const splideEl = query.querySelector('.splide');
      const list = splideEl?.querySelector('.splide__list');
      if (!splideEl || !list) return;

      const count = data.length;
      const useLoop = count >= 6;
      // USP slides plus ◆ between them (not after the last when static)
      const staticPerPage = count > 1 ? count * 2 - 1 : 1;

      data.forEach((item, index) => {
        list.insertAdjacentHTML('beforeend', /* html */ `
          <div class="splide__slide usp-strip__slide">
            <span class="usp-strip__text">${item.usp}</span>
          </div>
        `);

        const isLast = index === count - 1;
        if (useLoop || !isLast) {
          list.insertAdjacentHTML('beforeend', /* html */ `
            <div class="splide__slide usp-strip__slide usp-strip__slide--separator" aria-hidden="true">
              <span class="usp-strip__separator">◆</span>
            </div>
          `);
        }
      });

      const slider = new Splide(splideEl, {
        arrows: false,
        pagination: false,
        ...(useLoop
          ? { type: 'loop', autoWidth: true, drag: true }
          : { type: 'slide', perPage: staticPerPage, drag: false }),
      });

      slider.mount();
    } catch (error) {
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();

/**
 * Animate
 * Phrases and diamonds rise in, left to right, as the strip enters.
 */
(() => {
  document.querySelectorAll('.animate .usp-strip').forEach((strip) => {
    const pieces = strip.querySelectorAll(
      '.usp-strip__slide:not(.splide__slide--clone) .usp-strip__text, .usp-strip__slide:not(.splide__slide--clone) .usp-strip__separator',
    );
    if (!pieces.length) return;

    pieces.forEach((piece) => {
      piece.style.opacity = '0';
    });

    animate(pieces, {
      y: ['8px', 0],
      opacity: [0, 1],
      duration: 700,
      ease: 'outCubic',
      delay: stagger(90),
      autoplay: onScroll({
        target: strip,
        enter: 'bottom bottom',
        sync: 'play',
        debug: false,
      }),
    });
  });
})();
